import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import PasswordCliente from "./PasswordCliente";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";

// Los campos que apuntan a otro catalogo (almacen, grupo, vendedor, empresa) no
// pueden ir vacios: Mongo no sabe convertir "" a un id. Como ahora lo unico
// obligatorio es el nombre comercial y la empresa, los demas simplemente no se
// mandan cuando el usuario no los captura.
const REFS = ["areas", "grupos", "vendedor", "empresas", "departamentosClientes"];
const limpiaRefs = (cuerpo) => {
  const salida = { ...cuerpo };
  REFS.forEach((k) => {
    if (!salida[k] || salida[k] === "0") delete salida[k];
  });
  return salida;
};

function ListadoClientes() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_CUENTAS_CLIENTES = process.env.REACT_APP_URL_CUENTAS_CLIENTES;


  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [mailTo, setMailTo] = useState("");
  const [idPassword, setIdPassword] = useState("");
  const [idEditCliente, setIdEditCliente] = useState("");
  const [selectedGrupoEdit, setSelectedGrupoEdit] = useState("");
  const [selectedDepartamentoEdit, setSelectedDepartamentoEdit] = useState("");
  const [nombre_comercial, setNombreComercial] = useState("");
  const [razon_social, setRazonSocial] = useState("");
  const [RFC, setRFC] = useState("");
  const [calle, setCalle] = useState("");
  const [numero_ext, setNumeroExt] = useState("");
  const [numero_int, setNumeroInt] = useState("");
  const [delegacion, setDelegacion] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [cp, setCP] = useState("");
  const [colonia, setColonia] = useState("");
  const [codigo, setCodigo] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [telefono, setTelefono] = useState("");
  const [email, setEmail] = useState("");
  const [emailViejo, setEmailViejo] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [selectedVendedorName, setSelectedVendedorName] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [calificadora, setCalificadora] = useState("");
  const [categoria, setCategoria] = useState("");
  const [ultimo_pago, setUltimoPago] = useState("");
  const [forma_pago, setFormaPago] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedAreaEdit, setSelectedAreaEdit] = useState("");
  const [plazo, setPlazo] = useState("");
  const [alertasVentas, setAlertasVentas] = useState("");
  const [alertasEdoCta, setAlertasEdoCta] = useState("");
  const [alertasMarketing, setAlertasMarketing] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedEmpresaEdit, setSelectedEmpresaEdit] = useState("");
    const [telefonoCobranza, setTelefonoCobranza] = useState("");
    const [telefonoCompras, setTelefonoCompras] = useState("");
    const [encargadaPagos, setEncargadaPagos] = useState("");

  // Info
  const [idInfo, setIdInfo] = useState("");
  const [telefono_info, setTelefonoInfo] = useState("");
  const [nombre_comercial_info, setNombreComercialInfo] = useState("");
  const [email_info, setEmailInfo] = useState("");
  const [forma_pago_info, setFormaPagoInfo] = useState("");
  const [razon_social_info, setRazonSocialInfo] = useState("");
  const [grupo_info, setGruposInfo] = useState("");
  const [direccion_info, setDireccionInfo] = useState("");
  const [colaborador_info, setColaboradorInfo] = useState("");
  const [observaciones_info, setObservacionesInfo] = useState("");

  const [selectedEmpresaFiltro, setSelectedEmpresaFiltro] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalPassword, setModalPassword] = useState(false);
  const togglePassword = () => setModalPassword(!modalPassword);

  const [activo, setActivo] = useState("Si");
  const [vendedor, setVendedor] = useState("");
  const [departamentoFiltro, setDepartamentoFiltro] = useState("");
  const [almacenFiltro, setAlmacenFiltro] = useState(AREAS_CEDIS);
  const [estadoFiltro, setEstadoFiltro] = useState("");
  const [grupo, setGrupo] = useState(""); 
  const [regFiscal, setRegFiscal] = useState("");
  const [usoCFDI, setusoCFDI] = useState("");
  const [formaPagoSAT, setFormaPagoSAT] = useState("");
  const [condicionesPagoSAT, setCondicionesPagoSAT] = useState("");
  const [metodoPagoSAT, setMetodoPagoSAT] = useState("");
  const [limiteCredito, setLimiteCredito] = useState("");


   const [cuentas, setCuentas] = useState([]);
    const [idClienteCuenta, setIdClienteCuenta] = useState("");
    const [modalCuenta, setModalCuenta] = useState(false);
    const toggleCuenta = () => setModalCuenta(!modalCuenta);

    const [inputFieldsCuentas, setInputFieldsCuentas] = useState([
      {
        id: uuidv4(),
        banco: "",
        cuenta: "",
        rfc:"",
      },
    ]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;



  useMemo(() => {
    if (user.areas) {
        axios
          .get(`${URL_CLIENTES}GeneralActivos`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((response) => {
            let allClientes = response.data;
            if (user.vendedor === "Si") {
              allClientes = allClientes.filter(cliente => cliente.vendedor?.[0]?.email === user.email);
            }
            // Array para pagination
            let arrayTabla = allClientes
              .sort((a, b) =>
                a.nombre_comercial > b.nombre_comercial ? 1 : -1
              )
              .map((a) => {
                return {
                  _id: a._id,
                  activo: a.is_active,
                  telefono: a.telefono,
                  email: a.email,
                  calle: a.calle,
                  numero_ext: a.numero_ext,
                  numero_int: a.numero_int,
                  pais: a.pais,
                  estado: a.estado,
                  ciudad: a.ciudad,
                  delegacion: a.delegacion,
                  colonia: a.colonia,
                  codigo: a.codigo,
                  cp: a.cp,
                  nombre_comercial: a.nombre_comercial,
                  razon_social: a.razon_social,
                  RFC: a.RFC,
                  grupo: a.grupos?.[0]?.name || "",
                  idGrupo: a.grupos?.[0]?._id || "",
                  departamento: a.departamentosClientes?.[0]?.name || "",
                  idDepartamento: a.departamentosClientes?.[0]?._id || "",
                  vendedor: a.vendedor?.[0] ? a.vendedor?.[0]?.nombre + " " + a.vendedor?.[0]?.apellido : "",
                  idVendedor: a.vendedor?.[0]?._id || "",
                  observaciones: a.observaciones,
                  calificadora: a.calificadora,
                  ultimo_pago: a.ultimo_pago,
                  forma_pago: a.forma_pago,
                  area: a.areas?.[0]?.name || "",
                  idArea: a.areas?.[0]?._id || "",
                  plazo: a.plazo,
                  alertasVentas: a.alertasVentas,
                  alertasEdoCta: a.alertasEdoCta,
                  alertasMarketing: a.alertasMarketing,
                  empresa: a.empresas?.[0]?.name || "",
                  idEmpresa: a.empresas?.[0]?._id || "",
                  telefonoCobranza: a.telefonoCobranza,
                  telefonoCompras: a.telefonoCompras,
                  encargadaPagos: a.encargadaPagos,
                  categoria: a.categoria,
                  regFiscal: a.regFiscal,
                  usoCFDI: a.usoCFDI,
                  formaPagoSAT: a.formaPagoSAT,
                  condicionesPagoSAT: a.condicionesPagoSAT,
                  metodoPagoSAT: a.metodoPagoSAT,
                  fiscal: a.fiscal,
                  limiteCredito: a.limiteCredito,
                };
              })
              .filter(function (el) {
                return el != null;
              });

            let dataFinal = Object.values(arrayTabla);

            setComments(dataFinal);
            //
          })
          .catch((err) => {
            console.log(err);
          })
    }
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [user, activo, almacenFiltro]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (estadoFiltro == 0 || estadoFiltro == a.estado) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return [
          a.codigo,
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupo,
          a.vendedor,
          a.area,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Telefono",
          "Mail",
          "Grupo",
          "Vendedor",
          "Almacen",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
    });
    doc.save(`Clientes.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (estadoFiltro == 0 || estadoFiltro == a.estado) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return {
          Id: a._id,
          Activo: a.activo,
          Codigo: a.codigo,
          Nombre: a.nombre_comercial,
          RazonSocial: a.razon_social,
          RFC: a.RFC,
          Calle: a.calle,
          NoExt: a.numero_ext,
          NoInt: a.numero_int,
          Pais: a.pais,
          Estado: a.estado,
          Ciudad: a.ciudad,
          Delegacion: a.delegacion,
          Colonia: a.colonia,
          CP: a.cp,
          Telefono: a.telefono,
          Mail: a.email,
          Vendedor: a.vendedor,
          FormaPago: a.forma_pago,
          Plazo: a.plazo,
          RegFiscal: a.regFiscal,
          Grupo: a.grupo,
          Almacen: a.area,
          Observaciones: a.observaciones,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoClientes";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoClientes",
        sheetFilter: [
          "Id",
          "Activo",
          "Codigo",
          "Nombre",
          "RazonSocial",
          "RFC",
          "Calle",
          "NoExt",
          "NoInt",
          "Pais",
          "Estado",
          "Ciudad",
          "Delegacion",
          "Colonia",
          "CP",
          "Telefono",
          "Mail",
          "Vendedor",
          "FormaPago",
          "Plazo",
          "RegFiscal",
          "Grupo",
          "Almacen",
          "Observaciones",
        ],
        sheetHeader: [
          "Id",
          "Activo",
          "Codigo",
          "Nombre",
          "RazonSocial",
          "RFC",
          "Calle",
          "NoExt",
          "NoInt",
          "Pais",
          "Estado",
          "Ciudad",
          "Delegacion",
          "Colonia",
          "CP",
          "Telefono",
          "Mail",
          "Vendedor",
          "FormaPago",
          "Plazo",
          "RegFiscal",
          "Grupo",
          "Almacen",
          "Observaciones",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (grupo == 0 || grupo == a.idGrupo) &&
        (estadoFiltro == 0 || estadoFiltro == a.estado) &&
        (vendedor == 0 || vendedor == a.idVendedor)
      ) {
        return [
          a.codigo,
          a.nombre_comercial,
          a.telefono,
          a.email,
          a.grupo,
          a.vendedor,
          a.area,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 30, 30);
    doc.text(`Listado Clientes`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Nombre",
          "Telefono",
          "Mail",
          "Grupo",
          "Vendedor",
          "Almacen",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Clientes",
          email: mailTo,
          fileName: "ListadoClientes.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    idEdit,
    telefono,
    email,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    nombre_comercial,
    razon_social,
    RFC,
    gruposId,
    vendedorNombre,
    vendedorId,
    observaciones,
    calificadora,
    ultimo_pago,
    forma_pago,
    codigo,
    departamentoId,
    idArea,
    plazo,
    alertasVentas,
    alertasEdoCta,
    alertasMarketing,
    idEmpresa,
    telefonoCobranza,
    telefonoCompras,
    encargadaPagos,
    categoria,
    usoCFDI, 
    regFiscal, 
    formaPagoSAT,
    condicionesPagoSAT,
    metodoPagoSAT,
    limiteCredito
  ) {
    setTelefono(telefono);
    setEmail(email);
    setEmailViejo(email);
    setCalle(calle);
    setNumeroExt(numero_ext);
    setNumeroInt(numero_int);
    setPais(pais);
    setEstado(estado);
    setCiudad(ciudad);
    setDelegacion(delegacion);
    setColonia(colonia);
    setCP(cp);
    setNombreComercial(nombre_comercial);
    setRazonSocial(razon_social);
    setRFC(RFC);
    setSelectedGrupoEdit(gruposId);
    setSelectedDepartamentoEdit(departamentoId);
    setSelectedVendedorName(vendedorNombre);
    setSelectedVendedor(vendedorId);
    setObservaciones(observaciones);
    setCalificadora(calificadora);
    setUltimoPago(ultimo_pago);
    setFormaPago(forma_pago);
    setCodigo(codigo);
    setIdEditCliente(idEdit);
    setSelectedAreaEdit(idArea);
    setPlazo(plazo);
    setAlertasVentas(alertasVentas)
    setAlertasEdoCta(alertasEdoCta)
    setAlertasMarketing(alertasMarketing)
    setSelectedEmpresaEdit(idEmpresa)
    setTelefonoCobranza(telefonoCobranza)
    setTelefonoCompras(telefonoCompras)
    setEncargadaPagos(encargadaPagos)
    setCategoria(categoria)
    setusoCFDI(usoCFDI)
    setRegFiscal(regFiscal)
    setFormaPagoSAT(formaPagoSAT);
    setCondicionesPagoSAT(condicionesPagoSAT);
    setMetodoPagoSAT(metodoPagoSAT);
    setLimiteCredito(limiteCredito);
    toggleEdit();
  }

  function Info(
    id,
    nombre_comercial,
    telefono,
    email,
    forma_pago,
    razon_social,
    grupos,
    calle,
    numero_ext,
    numero_int,
    colonia,
    colaboradoresName,
    observaciones
  ) {
    setIdInfo(id);
    setNombreComercialInfo(nombre_comercial);
    setTelefonoInfo(telefono);
    setEmailInfo(email);
    setFormaPagoInfo(forma_pago);
    setRazonSocialInfo(razon_social);
    setGruposInfo(grupos);
    setDireccionInfo(
      calle + " " + numero_ext + " " + numero_int + " " + colonia
    );
    setColaboradorInfo(colaboradoresName);
    setObservacionesInfo(observaciones);
    toggle();
  }

  function editClientes(event) {
    event.preventDefault();
    const URL_CLIENTES_EDIT = `${process.env.REACT_APP_URL_CLIENTES}/${idEditCliente}`;
        axios.patch(
          URL_CLIENTES_EDIT,
          limpiaRefs({
            nombre_comercial,
            razon_social,
            RFC,
            calle,
            numero_ext,
            numero_int,
            delegacion,
            estado,
            pais,
            cp,
            colonia,
            ciudad,
            telefono,
            email,
            grupos: selectedGrupoEdit,
            vendedor: selectedVendedor,
            observaciones,
            calificadora,
            ultimo_pago,
            forma_pago,
            // codigo,
            areas: selectedAreaEdit,
            plazo,
            regFiscal,
            alertasVentas,
            alertasEdoCta,
            alertasMarketing,
            empresas: selectedEmpresaEdit,
            telefonoCobranza,
            telefonoCompras,
            encargadaPagos,
            categoria,
            usoCFDI,
            regFiscal,
            formaPagoSAT,
            condicionesPagoSAT,
            metodoPagoSAT,
            limiteCredito,
          }),
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cliente",
            detalle: `${nombre_comercial}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        toggleEdit();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Estado", field: "estado", sortable: true },
    { name: "WhatsApp", field: "telefono", sortable: false },
    { name: "Empresa", field: "empresa", sortable: false },
    { name: "Calificadora", field: "calificadora", sortable: true },
    { name: "Categoria", field: "categoria", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.nombre_comercial ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.estado ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.empresa ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.categoria ?? "").toString().includes(search)||
          String(comment.calificadora ?? "").toString().includes(search)||
          String(comment.codigo ?? "").toString().includes(search)
      );
    }
   
    if (estadoFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.estado ?? "").includes(estadoFiltro)
      );
    }
    if (selectedEmpresaFiltro) {
      computedComments = computedComments.filter((e) =>
        String(e.idEmpresa ?? "").includes(selectedEmpresaFiltro)
      );
    }
  
    setTotalItems(computedComments.length);

     //Sorting comments
     if (
      sorting.field &&
      sorting.field != "calificadora" &&
      sorting.field != "codigo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "calificadora" ||
        sorting.field == "codigo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "calificadora" ||
        sorting.field == "codigo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }
    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    vendedor,
    grupo,
    departamentoFiltro,
    almacenFiltro,
    estadoFiltro,
    selectedArea,
    selectedEmpresaFiltro
  ]);

  function cue(id, nombre_comercial) {
  setIdClienteCuenta(id);
  setNombreComercial(nombre_comercial);
  axios
    .get(`${URL_CUENTAS_CLIENTES}/cliente/${id}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allCuentas = res.data;
      setCuentas(allCuentas);
    })
    .catch((err) => {
      console.log(err);
    });
  toggleCuenta();
}

const handleChangeInputCuentasExistentes = (id, event) => {
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setCuentas(newCuentas);
};

const handleChangeInputCuentas = (id, event) => {
  const newInputFieldsCuentas = inputFieldsCuentas.map((i) => {
    if (id === i.id) {
      i[event.target.name] = event.target.value;
    }
    return i;
  });
  setInputFieldsCuentas(newInputFieldsCuentas);
};

function saveCuenta() {
  let totalCuen = cuentas.length + inputFieldsCuentas.length;
  cuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .patch(
          `${URL_CUENTAS_CLIENTES}/${a._id}`,
          {
            cuenta: a.cuenta,
            banco: a.banco,
            rfc: a.rfc,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuentas Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });

  // agregar inputFields
  inputFieldsCuentas.map((a) => {
    if (a.cuenta != "") {
      axios
        .post(
          `${URL_CUENTAS_CLIENTES}`,
          {
            clientes: idClienteCuenta,
            cuenta: a.cuenta,
            banco: a.banco,
            rfc: a.rfc,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then(() => {
          totalCuen = totalCuen - 1;
          if (totalCuen == 0) {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Cuenta Clientes",
                detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem(
                    "app_token"
                  )}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", `success`);
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } else {
      totalCuen = totalCuen - 1
      if (totalCuen == 0) {
        axios.post(
          URL_LOGS,
          {
            tipo: "Editar Cuenta Clientes",
            detalle: `Cliente ${idClienteCuenta} / Cuenta ${a.cuenta}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem(
                "app_token"
              )}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", `success`);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    }
  });
}

const handleAddFieldsCuentas = () => {
  setInputFieldsCuentas([
    ...inputFieldsCuentas,
    {
      id: uuidv4(),
      banco: "",
      cuenta: "",
      rfc:"",
    },
  ]);
};

const handleRemoveFieldsCuentas = (id) => {
  const values = [...inputFieldsCuentas];
  values.splice(
    values.findIndex((value) => value.id === id),
    1
  );
  setInputFieldsCuentas(values);
};

function altaCuenta(id) {
  axios
    .patch(
      `${URL_CUENTAS_CLIENTES}/${id}`,
      {
        is_active: "Si"
      },
      {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem(
            "app_token"
          )}`,
        },
      }
    )
    .then((data) => {
          Swal.fire("Good job!", "Creado con exito", "success");

          const newCuentas = cuentas.map((i) => {
            if (id === i._id) {
              i.is_active = "Si";
            }
            return i;
          });
          setCuentas(newCuentas);
       
    })
    .catch((error) => {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        // footer: `${error.response.data}`,
      });
      console.log(error);
    });
}

function bajaCuenta(id) {
axios
.patch(
`${URL_CUENTAS_CLIENTES}/${id}`,
{
is_active: "No"
},
{
headers: {
  Authorization: `Bearer: ${localStorage.getItem(
    "app_token"
  )}`,
},
}
)
.then((data) => {
  Swal.fire("Good job!", "Creado con exito", "success");
  const newCuentas = cuentas.map((i) => {
    if (id === i._id) {
      i.is_active = "No";
    }
    return i;
  });
  setCuentas(newCuentas);
})
.catch((error) => {
Swal.fire({
icon: "error",
title: "Oops...",
text: "Something went wrong!",
// footer: `${error.response.data}`,
});
console.log(error);
});
}
 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_clientes ? (
        <div className="card col-12">

              <Row>
                <Col md={8}>
                  {user.clientes_create ? (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      href="/ClientesCreate"
                    >
                      Nuevo Cliente
                    </Button>
                  ) : (
                    <Button
                      size="sm"
                      type="submit"
                      className="btn btn-success"
                      disabled
                    >
                      Nuevo Cliente
                    </Button>
                  )}
                  {/* <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
                </Col>
                <Col sm={4}>
                  <ButtonGroup id="logoutBoton">
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      onClick={PDFTabla}
                    >
                      PDF <i class="far fa-file-pdf"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      onClick={toggleMail}
                      color="info"
                    >
                      eMail <i class="fas fa-at"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="primary"
                      onClick={excel}
                    >
                      Excel <i class="far fa-file-excel"></i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
              <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
                <ModalHeader toggle={toggleMail}>
                  <h4>Enviar Listado Clientes</h4>
                </ModalHeader>
                <ModalBody>
                  <Label className="mr-sm-2">Email</Label>
                  <Input
                    className="col-sm-12"
                    type="text"
                    value={mailTo}
                    onChange={(e) => {
                      setMailTo(e.target.value);
                    }}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button size="sm" color="success" onClick={enviaMail}>
                    Enviar
                  </Button>
                </ModalFooter>
              </Modal>
              <h3 align="center">Clientes</h3>
              <div className="row">
                <div className="col-md-8">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-4 d-flex flex-row-reverse">
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <Row>
             
                <Col md={2}>
                  <Label>Estado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={estadoFiltro}
                    onChange={(e) => {
                      setEstadoFiltro(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                    <option value="BAJA CALIFORNIA NORTE">
                      BAJA CALIFORNIA NORTE
                    </option>
                    <option value="BAJA CALIFORNIA SUR">
                      BAJA CALIFORNIA SUR
                    </option>
                    <option value="CAMPECHE">CAMPECHE</option>
                    <option value="CHIAPAS">CHIAPAS</option>
                    <option value="CHIHUAHUA">CHIHUAHUA</option>
                    <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                    <option value="COAHUILA">COAHUILA</option>
                    <option value="COLIMA">COLIMA</option>
                    <option value="DURANGO">DURANGO</option>
                    <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                    <option value="GUANAJUATO">GUANAJUATO</option>
                    <option value="GUERRERO">GUERRERO</option>
                    <option value="HIDALGO">HIDALGO</option>
                    <option value="JALISCO">JALISCO</option>
                    <option value="MICHOACAN">MICHOACAN</option>
                    <option value="MORELOS">MORELOS</option>
                    <option value="NAYARIT">NAYARIT</option>
                    <option value="NUEVO LEON">NUEVO LEON</option>
                    <option value="OAXACA">OAXACA</option>
                    <option value="PUEBLA">PUEBLA</option>
                    <option value="QUERETARO">QUERETARO</option>
                    <option value="QUINTANA ROO">QUINTANA ROO</option>
                    <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                    <option value="SINALOA">SINALOA</option>
                    <option value="SONORA">SONORA</option>
                    <option value="TABASCO">TABASCO</option>
                    <option value="TAMAULIPAS">TAMAULIPAS</option>
                    <option value="TLAXCALA">TLAXCALA</option>
                    <option value="VERACRUZ">VERACRUZ</option>
                    <option value="YUCATAN">YUCATAN</option>
                    <option value="ZACATECAS">ZACATECAS</option>
                  </Input>
                </Col>


                <Col md={2}>
                  <Label>Activo</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={activo}
                    onChange={(e) => {
                      setActivo(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>

                <Col md={2}>
              <Label>Empresas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEmpresaFiltro}
                onChange={(e) => {
                  setSelectedEmpresaFiltro(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {empresas
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
              </Row>
              <br />
              <Table
                size="sm"
                striped
                borderless
                className="table-responsive-xl"
              >
                <TableHeader
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData.map((p) => {
                    {
                      return (
                        <tr>
                          <td>{p.codigo}</td>
                          <td> {p.nombre_comercial}</td>
                          <td> {p.estado}</td>
                          <td>{p.telefono}</td>
                          <td>{p.empresa}</td>
                          <td>
                            {p.calificadora == 1 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 2 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 3 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 4 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : p.calificadora == 5 ? (
                              <Row>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                                <i class="fas fa-star"></i>
                              </Row>
                            ) : undefined}
                          </td>
                          <td>{p.categoria}</td>
                          <td>
                            {user.clientes_create ? (
                              <div>
                              
                                <Button
                                  color="success"
                                  size="sm"
                                  onClick={(e) =>
                                    Info(
                                      p._id,
                                      p.nombre_comercial,
                                      p.telefono,
                                      p.email,
                                      p.forma_pago,
                                      p.razon_social,
                                      p.grupo,
                                      p.calle,
                                      p.numero_ext,
                                      p.numero_int,
                                      p.colonia,
                                      p.vendedor,
                                      p.observaciones
                                    )
                                  }
                                  id="Detalle"
                                >
                                  <i class="fas fa-file-alt"></i>
                                </Button>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    jalaInfo(
                                      p._id,
                                      p.telefono,
                                      p.email,
                                      p.calle,
                                      p.numero_ext,
                                      p.numero_int,
                                      p.pais,
                                      p.estado,
                                      p.ciudad,
                                      p.delegacion,
                                      p.colonia,
                                      p.cp,
                                      p.nombre_comercial,
                                      p.razon_social,
                                      p.RFC,
                                      p.idGrupo,
                                      p.vendedor,
                                      p.idVendedor,
                                      p.observaciones,
                                      p.calificadora,
                                      p.ultimo_pago,
                                      p.forma_pago,
                                      p.codigo,
                                      p.idDepartamento,
                                      p.idArea,
                                      p.plazo,
                                      p.alertasVentas,
                                      p.alertasEdoCta,
                                      p.alertasMarketing,
                                      p.idEmpresa,
                                      p.telefonoCobranza,
                                      p.telefonoCompras,
                                      p.encargadaPagos,
                                      p.categoria,
                                      p.usoCFDI, 
                                      p.regFiscal,
                                      p.formaPagoSAT,
                                      p.condicionesPagoSAT,
                                      p.metodoPagoSAT,
                                      p.limiteCredito
                                    )
                                  }
                                >
                                  <i class="far fa-edit"></i>
                                </Button>
                                 <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) =>
                                    cue(p._id, p.nombre_comercial)
                                  }
                                >
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                                {/* <Button
                              color="success"
                              id="Password"
                              size="sm"
                              onClick={(e) => jalaInfoPassword(p._id)}
                            >
                              <i class="fas fa-user-lock"></i>
                            </Button> */}
                                <Baja
                                  idStatus={p._id}
                                  is_active={p.activo}
                                  URL_BAJA={process.env.REACT_APP_URL_CLIENTES}
                                />
                              </div>
                            ) : (
                              <div>
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="far fa-edit"></i>
                                </Button>
                                <Button
                                  color="success"
                                  id="Password"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-user-lock"></i>
                                </Button>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    }
                  })}
                </tbody>
              </Table>
              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
          
        </div>
      ) : undefined}
      <br />

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Informacion del Cliente</h4>
        </ModalHeader>
        <ModalBody>
          <div className="card container">
            <Table size="sm" borderless>
              <tbody>
                <tr>
                  <td>Nombre Comercial</td>
                  <td>{nombre_comercial_info}</td>
                </tr>
                <tr>
                  <td>WhatsApp</td>
                  <td>{telefono_info}</td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>{email_info}</td>
                </tr>
                <tr>
                  <td>Forma de Pago</td>
                  <td>{forma_pago_info}</td>
                </tr>
                <tr>
                  <td>Razon Social</td>
                  <td>{razon_social_info}</td>
                </tr>
                <tr>
                  <td>Grupo</td>
                  <td>{grupo_info}</td>
                </tr>
                <tr>
                  <td>Direccion</td>
                  <td>{direccion_info}</td>
                </tr>
                <tr>
                  <td>Cobrador</td>
                  <td>{colaborador_info} </td>
                </tr>
                <tr>
                  <td>Observaciones</td>
                  <td>{observaciones_info}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalPassword} toggle={togglePassword}>
        <ModalHeader toggle={togglePassword}>
          <h4>Cambio de contraseña</h4>
        </ModalHeader>
        <ModalBody>
          <PasswordCliente idCliente={idPassword} />
        </ModalBody>
      </Modal>

      <Modal size="xl" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>Editar cliente {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>Codigo</Label>
              <Input
                type="text"
                placeholder="Codigo"
                value={codigo}
                disabled
              />
            </Col>
            <Col md={3}>
              <Label>Nombre Comercial <span style={{ color: "#dc2626" }}>*</span></Label>
              <Input
                type="text"
                placeholder="Nombre Comercial"
                value={nombre_comercial}
                required
                onChange={(e) => {
                  setNombreComercial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Razon Social</Label>
              <Input
                type="text"
                placeholder="Razon Social"
                value={razon_social}
                onChange={(e) => {
                  setRazonSocial(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>RFC</Label>
              <Input
                type="text"
                placeholder="RFC"
                value={RFC}
                onChange={(e) => {
                  setRFC(e.target.value);
                }}
              />
            </Col>
          </Row>

              <Row>
              <Col md={3}>
              <Label>Telefono Compras</Label>
                <Input
                  type="text"
                  placeholder="Telefono Compras"
                  value={telefonoCompras}
                  onChange={(e) => {
                    setTelefonoCompras(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
              <Label>Telefono Cobranza</Label>
                <Input
                  type="text"
                  placeholder="Telefono Cobranza"
                  value={telefonoCobranza}
                  onChange={(e) => {
                    setTelefonoCobranza(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
              <Label>Encargada Pagos</Label>
                <Input
                  type="text"
                  placeholder="Encargada Pagos"
                  value={encargadaPagos}
                  onChange={(e) => {
                    setEncargadaPagos(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
              <Label>Categoria</Label>
                <Input
                  type="select"
                  placeholder="Categoria"
                  value={categoria}
                  onChange={(e) => {
                    setCategoria(e.target.value);
                  }}
                >

                  <option value="Normal">Normal</option>
                  <option value="Moroso">Moroso</option>
                  <option value="Incobrable">Incobrable</option>
                </Input>
              </Col>
              </Row>
          <Row>
            <Col md={6}>
              <Label>Calle</Label>
              <Input
                type="text"
                placeholder="Calle"
                value={calle}
                onChange={(e) => {
                  setCalle(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Ext</Label>
              <Input
                type="text"
                placeholder="No. Ext"
                value={numero_ext}
                onChange={(e) => {
                  setNumeroExt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>No. Int</Label>
              <Input
                type="text"
                placeholder="No. Int"
                value={numero_int}
                onChange={(e) => {
                  setNumeroInt(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Pais</Label>
              <Input
                type="text"
                placeholder="Pais"
                value={pais}
                onChange={(e) => {
                  setPais(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>Estado</Label>
              <Input
                type="select"
                value={estado}
                onChange={(e) => {
                  setEstado(e.target.value);
                }}
              >
                <option value="">Selecciona</option>

                <option value="AGUASCALIENTES">AGUASCALIENTES</option>
                <option value="BAJA CALIFORNIA NORTE">
                  BAJA CALIFORNIA NORTE
                </option>
                <option value="BAJA CALIFORNIA SUR">BAJA CALIFORNIA SUR</option>
                <option value="CAMPECHE">CAMPECHE</option>
                <option value="CHIAPAS">CHIAPAS</option>
                <option value="CHIHUAHUA">CHIHUAHUA</option>
                <option value="CIUDAD DE MEXICO">CIUDAD DE MEXICO</option>
                <option value="COAHUILA">COAHUILA</option>
                <option value="COLIMA">COLIMA</option>
                <option value="DURANGO">DURANGO</option>
                <option value="ESTADO DE MEXICO">ESTADO DE MEXICO</option>
                <option value="GUANAJUATO">GUANAJUATO</option>
                <option value="GUERRERO">GUERRERO</option>
                <option value="HIDALGO">HIDALGO</option>
                <option value="JALISCO">JALISCO</option>
                <option value="MICHOACAN">MICHOACAN</option>
                <option value="MORELOS">MORELOS</option>
                <option value="NAYARIT">NAYARIT</option>
                <option value="NUEVO LEON">NUEVO LEON</option>
                <option value="OAXACA">OAXACA</option>
                <option value="PUEBLA">PUEBLA</option>
                <option value="QUERETARO">QUERETARO</option>
                <option value="QUINTANA ROO">QUINTANA ROO</option>
                <option value="SAN LUIS POTOSI ">SAN LUIS POTOSI</option>
                <option value="SINALOA">SINALOA</option>
                <option value="SONORA">SONORA</option>
                <option value="TABASCO">TABASCO</option>
                <option value="TAMAULIPAS">TAMAULIPAS</option>
                <option value="TLAXCALA">TLAXCALA</option>
                <option value="VERACRUZ">VERACRUZ</option>
                <option value="YUCATAN">YUCATAN</option>
                <option value="ZACATECAS">ZACATECAS</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Ciudad</Label>
              <Input
                type="text"
                placeholder="Ciudad"
                value={ciudad}
                onChange={(e) => {
                  setCiudad(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Delegacion</Label>
              <Input
                type="text"
                placeholder="Delegacion o Municipio"
                value={delegacion}
                onChange={(e) => {
                  setDelegacion(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Colonia</Label>
              <Input
                type="text"
                placeholder="Colonia"
                value={colonia}
                onChange={(e) => {
                  setColonia(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>CP</Label>
              <Input
                type="text"
                placeholder="CP"
                value={cp}
                onChange={(e) => {
                  setCP(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>WhatsApp</Label>
              <Input
                type="text"
                placeholder="Telefono"
                value={telefono}
                onChange={(e) => {
                  setTelefono(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>Email</Label>
              <Input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Vendedor</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedVendedor}
                onChange={(e) => {
                  setSelectedVendedor(e.target.value);
                }}
              >
                <option value="0">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label>Forma de Pago</Label>
              <Input
                type="select"
                placeholder="Forma de Pago"
                value={forma_pago}
                onChange={(e) => {
                  setFormaPago(e.target.value);
                }}
              >
                <option value="0">Forma de Pago</option>
                <option value="Contado">Contado</option>
                <option value="Credito">Credito</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>Plazo</Label>
              <Input
                type="select"
                placeholder="Plazo"
                value={plazo}
                onChange={(e) => {
                  setPlazo(e.target.value);
                }}
              >
                <option value="">Plazo</option>
                <option value="0">0</option>
                <option value="30">30</option>
                <option value="60">60</option>
                <option value="90">90</option>
                <option value="120">120</option>
                <option value="150">150</option>
                <option value="180">180</option>
              </Input>
            </Col>


            <Col md={3}>
              <Label className="mr-sm-2">Grupo</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedGrupoEdit}
                onChange={(e) => {
                  setSelectedGrupoEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Grupo</option>
                {grupos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Almacen</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedAreaEdit}
                onChange={(e) => {
                  setSelectedAreaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona un almacen</option>
                {areas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                              return <option value={a._id}>{a.name}</option>;
                        })}
              </Input>
            </Col>

            <Col md={3}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="text"
                placeholder="Observaciones"
                value={observaciones}
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>Calificadora</Label>
              <Input
                type="select"
                placeholder="Calificadora"
                value={calificadora}
                onChange={(e) => {
                  setCalificadora(e.target.value);
                }}
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
              </Input>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
                <Label className="mr-sm-2">Alertas Ventas</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasVentas}
                  onChange={(e) => {
                    setAlertasVentas(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Estado Cuenta</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasEdoCta}
                  onChange={(e) => {
                    setAlertasEdoCta(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Alertas Marketing</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={alertasMarketing}
                  onChange={(e) => {
                    setAlertasMarketing(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Si">Si</option>
                  <option value="No">No</option>
                </Input>
              </Col>

              <Col md={3}>
              <Label className="mr-sm-2">Empresa <span style={{ color: "#dc2626" }}>*</span></Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedEmpresaEdit}
                required
                onChange={(e) => {
                  setSelectedEmpresaEdit(e.target.value);
                }}
              >
                <option value="0">Selecciona una Empresa</option>
                {empresas
                  .sort((a, b) =>
                    a.name > b.name ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>  
            
            </Row>
            <Row>
            <Col md={3}>
                <Label>Regimen Fiscal</Label>
                <Input
                  type="select"
                  placeholder="RegFiscal"
                  value={regFiscal}
                  onChange={(e) => {
                    setRegFiscal(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="0">0</option>
                  <option value="601">601 General de Ley Personas Morales</option>
                  <option value="603">603 Personas Morales con Fines no Lucrativos</option>
                  <option value="605">605 Sueldos y Salarios e Ingresos Asimilados al Salario</option>
                  <option value="608">608 Demas Ingresos</option>
                  <option value="612">612 Personas Físicas con Actividades Empresariales y Profesionales</option>
                  <option value="616">616 Sin Obligacion Fiscal</option>
                  <option value="621">621 Incorporacion Fiscal</option>
                  <option value="623">623 Opcional para Grupos de Sociedades</option>
                  <option value="624">624 Régimen de los Coordinados</option>
                  <option value="625">625 Reg. de las act. emp. cpn ingresos a traves de plat. tec.</option>
                  <option value="626">626 Regimen simplificado de Confianza</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Uso de CDFI
                </Label>
                <Input
                  type="select"
                  placeholder="Uso de CDFI"
                  value={usoCFDI}
                  onChange={(e) => {
                    setusoCFDI(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="G01">G01 Adquisición de mercancías</option>
                  <option value="G03">G03 Gastos en general</option>
                  <option value="G23">G23 Opcional para grupos de sociedades</option>
                  <option value="S01">S01 Sin efectos fiscales</option>
                  </Input>
              </Col>
              <Col md={3}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSAT}
                  onChange={(e) => {
                    setFormaPagoSAT(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

              <Col md={3}>
                <Label>Metodo Pago Fiscal</Label>
                <Input
                  type="select"
                  value={metodoPagoSAT}
                  onChange={(e) => {
                    setMetodoPagoSAT(e.target.value);
                  }}
                >

              <option value="">Selecciona</option>
              <option value="PUE">PUE (Pago de Una Sola Exhibición)</option>
              <option value="PPD">PPD (Pago en Parcialidades o Diferido)</option>
                </Input>
              </Col>

              </Row>
              <Row>

              <Col md={3}>
                <Label>Condiciones de Pago Fiscal</Label>
                <Input
                  type="text"
                  value={condicionesPagoSAT}
                  onChange={(e) => {
                    setCondicionesPagoSAT(e.target.value);
                  }}
                />
              </Col>
              <Col md={3}>
                <Label>Limite de Credito</Label>
                <Input
                  type="number"
                  value={limiteCredito}
                  onChange={(e) => {
                    setLimiteCredito(e.target.value);
                  }}
                />
              </Col>
            </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editClientes}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>


            <Modal size="xl" isOpen={modalCuenta} toggle={toggleCuenta}>
        <ModalHeader toggle={toggleCuenta}>
          <h4>Cuentas {nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
        <Table striped borderless>
                  <thead>
                    <tr>
                      <th>Banco</th>
                      <th>RFC Banco</th>
                      <th>Cuentas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                         <td>
                          <Input
                            type="text"
                            name="rfc"
                            value={a.rfc}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentasExistentes(a._id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            // maxLength="4" // Limit to 4 digits
                            // pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentasExistentes(a._id, event);
                            }}
                          />
                        </td>
                        <td>
                          {a.is_active == "Si"?(
                            <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={() => bajaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-times-circle"></i>
                          </Button>
                          ):(
                            <Button
                            size="sm"
                            className="btn"
                            color="primary"
                            onClick={() => altaCuenta(a._id)}
                            tabindex="-1"
                          >
                            <i class="far fa-check-circle"></i>
                          </Button>
                          )}
                         
                        </td>
                      </tr>
                      // </div>
                    ))}

              {inputFieldsCuentas.map((a) => (
                      <tr>
                         <td>
                          <Input
                            type="text"
                            name="banco"
                            value={a.banco}
                            key={a.id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                         <td>
                          <Input
                            type="text"
                            name="rfc"
                            value={a.rfc}
                            key={a._id}
                            onChange={(e) => {
                              handleChangeInputCuentas(a.id, e);
                            }}
                          />
                        </td>
                        <td>
                          <Input
                            name="cuenta"
                            type="text"
                            value={a.cuenta}
                            // maxLength="4" // Limit to 4 digits
                            // pattern="\d{1,4}" 
                            onChange={(event) => {
                              handleChangeInputCuentas(a.id, event);
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            disabled={a.length === 1}
                            onClick={() => handleRemoveFieldsCuentas(a.id)}
                            tabindex="-1"
                          >
                            <i class="fas fa-minus"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={handleAddFieldsCuentas}
                            tabindex="-1"
                          >
                            <i class="fas fa-plus"></i>
                          </Button>
                        </td>
                      </tr>
                      // </div>
                    ))}

                  </tbody>
                  <br />
                </Table>
                <br />
                <Row>
                <Button className="btn btn-success" onClick={saveCuenta}>
                Registrar
              </Button>
                </Row>

        </ModalBody>
      </Modal>
      {loader}
    </>
  );
}

export default ListadoClientes;
